/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Divider, Grid, Typography } from '@coursera/cds-core';

import _t from 'i18n!nls/coding-challenges';

const styles = {
  titleText: css`
    margin-bottom: 40px;
  `,
  headerText: css`
    color: var(--cds-color-blue-700);
    margin-bottom: 16px;
  `,
  sections: css`
    padding: 20px;
    margin-right: 50px;
  `,
  divider: css`
    border-radius: 10px;
  `,
  grid: css`
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
  `,
  center: css`
    text-align: left;
  `,
};

const LandingPageEligibility = () => {
  return (
    <div>
      <div>
        <Typography variant="h1semibold" css={styles.titleText}>
          {_t('Eligibility')}
        </Typography>
      </div>
      <Grid container css={styles.grid}>
        <Divider color="dark" orientation="vertical" />
        <Grid item md={4}>
          <div css={styles.sections}>
            <Typography variant="h1semibold" css={styles.headerText}>
              01
            </Typography>
            <Typography variant="h2">{_t('Registered Coursera learners.')}</Typography>
          </div>
        </Grid>
        <Divider css={styles.divider} color="dark" orientation="vertical" />
        <Grid item md={4}>
          <div css={styles.sections}>
            <Typography variant="h1semibold" css={styles.headerText}>
              02
            </Typography>
            <Typography variant="h2">
              {_t('Learners who have enrolled and completed Data Science courses on Coursera.')}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPageEligibility;
